import React from 'react';
import Checkout from '../features/payment/components/Checkout';

const CheckoutPage = () => {
  return <Checkout />;
};

export default CheckoutPage;
